(function () {
  'use strict';

  var SECTION_TYPE = 'oddit-cart-drawer';
  var activeCurrency = null;
  var instances = [];

  // -------------------------------------------------------
  // Money / currency helpers
  // -------------------------------------------------------

  function getActiveCurrency() {
    if (activeCurrency) return activeCurrency;
    if (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) {
      return window.Shopify.currency.active;
    }
    return 'USD';
  }

  function formatMoney(cents) {
    var currency = getActiveCurrency();
    var amount = (Number(cents) || 0) / 100;
    try {
      return new Intl.NumberFormat(undefined, {
        style: 'currency',
        currency: currency
      }).format(amount);
    } catch (e) {
      return amount.toFixed(2) + ' ' + currency;
    }
  }

  // -------------------------------------------------------
  // Shopify Cart AJAX API
  // -------------------------------------------------------

  function fetchJSON(url, options) {
    options = options || {};
    var headers = {
      'Content-Type': 'application/json',
      'Accept': 'application/json',
      'X-Requested-With': 'XMLHttpRequest'
    };
    if (options.headers) {
      for (var k in options.headers) {
        if (Object.prototype.hasOwnProperty.call(options.headers, k)) {
          headers[k] = options.headers[k];
        }
      }
    }
    options.headers = headers;
    return fetch(url, options).then(function (res) {
      return res
        .json()
        .catch(function () {
          return {};
        })
        .then(function (data) {
          if (!res.ok) {
            var err = new Error(
              (data && (data.description || data.message)) ||
                'Cart request failed: ' + res.status
            );
            err.data = data;
            err.status = res.status;
            throw err;
          }
          return data;
        });
    });
  }

  function apiAddToCart(variantId, quantity, properties) {
    return fetchJSON('/cart/add.js', {
      method: 'POST',
      body: JSON.stringify({
        id: Number(variantId),
        quantity: Number(quantity) || 1,
        properties: properties || {},
        sections: SECTION_TYPE,
        sections_url: window.location.pathname
      })
    });
  }

  function apiAddMultipleToCart(items) {
    return fetchJSON('/cart/add.js', {
      method: 'POST',
      body: JSON.stringify({
        items: items || [],
        sections: SECTION_TYPE,
        sections_url: window.location.pathname
      })
    });
  }

  function apiChangeLine(payload) {
    payload.sections = SECTION_TYPE;
    payload.sections_url = window.location.pathname;
    return fetchJSON('/cart/change.js', {
      method: 'POST',
      body: JSON.stringify(payload)
    });
  }

  function apiGetCart() {
    return fetchJSON(
      '/cart.js?sections=' + encodeURIComponent(SECTION_TYPE) +
        '&sections_url=' + encodeURIComponent(window.location.pathname),
      { method: 'GET' }
    );
  }

  function extractItemsHTML(sectionHTML) {
    if (!sectionHTML) return null;
    try {
      var doc = new DOMParser().parseFromString(sectionHTML, 'text/html');
      var newList = doc.querySelector('[data-cart-items]');
      return newList ? newList.innerHTML : null;
    } catch (e) {
      return null;
    }
  }

  function escapeHTML(s) {
    if (s == null) return '';
    return String(s)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  // Build the inner HTML of [data-cart-items] from a cart.items array.
  // Used as a fallback when the section-rendering response doesn't
  // include the cart-drawer section HTML so the drawer still reflects
  // the live cart after add / change.
  function buildItemsHTML(items, opts) {
    items = items || [];
    opts = opts || {};
    var giftProductId = Number(opts.giftProductId) || 0;
    var protectionProductId = Number(opts.protectionProductId) || 0;

    var html = '';
    for (var i = 0; i < items.length; i++) {
      var it = items[i];
      var pid = Number(it.product_id);
      if (giftProductId && pid === giftProductId) continue;
      if (protectionProductId && pid === protectionProductId) continue;
      var itProps = it.properties || {};
      if (itProps._free_gift === 'true' || itProps._free_gift === true) continue;

      var title = it.product_title || it.title || '';
      var titleEsc = escapeHTML(title);
      var url = it.url || '#';
      var key = escapeHTML(it.key || '');
      var qty = Number(it.quantity) || 1;
      var img = it.image || (it.featured_image && it.featured_image.url) || '';

      var optionsHTML = '';
      if (
        !it.product_has_only_default_variant &&
        Array.isArray(it.options_with_values)
      ) {
        for (var o = 0; o < it.options_with_values.length; o++) {
          var op = it.options_with_values[o];
          optionsHTML +=
            '<p class="oddit-cart-drawer__item-option">' +
            escapeHTML(op.name) + ': ' + escapeHTML(op.value) +
            '</p>';
        }
      }
      if (it.selling_plan_allocation && it.selling_plan_allocation.selling_plan) {
        optionsHTML +=
          '<p class="oddit-cart-drawer__item-option">' +
          escapeHTML(it.selling_plan_allocation.selling_plan.name || '') +
          '</p>';
      }

      var priceHTML;
      if (
        typeof it.original_line_price === 'number' &&
        typeof it.final_line_price === 'number' &&
        it.original_line_price > it.final_line_price
      ) {
        var saving = it.original_line_price - it.final_line_price;
        priceHTML =
          '<p class="oddit-cart-drawer__item-price oddit-cart-drawer__item-price--discounted">' +
          '<span class="oddit-cart-drawer__item-price-original">' +
          formatMoney(it.original_line_price) +
          '</span>' +
          '<span class="oddit-cart-drawer__item-price-final">' +
          formatMoney(it.final_line_price) +
          '</span>' +
          '</p>' +
          '<p class="oddit-cart-drawer__item-savings">' +
          '<svg class="oddit-cart-drawer__item-savings-icon" width="14" height="14" viewBox="0 0 16 16" fill="none" aria-hidden="true">' +
          '<path d="M9.41 1H3a2 2 0 0 0-2 2v6.41a1 1 0 0 0 .29.71l5.59 5.59a1 1 0 0 0 1.41 0l6-6a1 1 0 0 0 0-1.41L9.71 1.29A1 1 0 0 0 9.41 1Z" stroke="currentColor" stroke-width="1.4" stroke-linejoin="round"/>' +
          '<circle cx="5" cy="5" r="1" fill="currentColor"/>' +
          '</svg>' +
          'Save ' + formatMoney(saving) +
          '</p>';
      } else {
        var linePrice = typeof it.final_line_price === 'number'
          ? it.final_line_price
          : (Number(it.line_price) || 0);
        priceHTML =
          '<p class="oddit-cart-drawer__item-price">' +
          formatMoney(linePrice) +
          '</p>';
      }

      var imageHTML = img
        ? '<img alt="' + titleEsc + '" loading="lazy" src="' + escapeHTML(img) + '">'
        : '';

      html +=
        '<li class="oddit-cart-drawer__item" data-cart-item="' + key + '">' +
        '<a class="oddit-cart-drawer__item-image" href="' + escapeHTML(url) + '" aria-label="' + titleEsc + '">' +
        imageHTML +
        '</a>' +
        '<div class="oddit-cart-drawer__item-details">' +
        '<h3 class="oddit-cart-drawer__item-title">' +
        '<a href="' + escapeHTML(url) + '">' + titleEsc + '</a>' +
        '</h3>' +
        optionsHTML +
        priceHTML +
        '<div class="oddit-cart-drawer__item-controls">' +
        '<div class="oddit-cart-drawer__qty">' +
        '<button type="button" class="oddit-cart-drawer__qty-btn" aria-label="Decrease quantity" data-cart-qty-decrease data-line-key="' + key + '">&ndash;</button>' +
        '<span class="oddit-cart-drawer__qty-value" aria-label="Quantity" data-cart-qty-value>' + qty + '</span>' +
        '<button type="button" class="oddit-cart-drawer__qty-btn" aria-label="Increase quantity" data-cart-qty-increase data-line-key="' + key + '">+</button>' +
        '</div>' +
        '<button type="button" class="oddit-cart-drawer__remove" data-cart-remove data-line-key="' + key + '" aria-label="Remove ' + titleEsc + '">Remove</button>' +
        '</div>' +
        '</div>' +
        '</li>';
    }
    return html;
  }

  /* TL-98: build the gift-wrap element from a cart line item. Used as a
     fallback in syncGiftBlock when Shopify's section re-render doesn't
     include the [data-cart-gift] block (timing race after the gift's
     /cart/add.js — the cart already lists the line but the rendered
     section HTML lags by a request, leaving the drawer stuck on the
     pre-gift state until the next page load). Mirrors the markup in
     sections/oddit-cart-drawer.liquid so styles and TL-137 behavior
     (clickable image + title, FREE GIFT badge with [threshold]) carry
     over. badge text is pulled from any pre-existing wrap so a manual
     change to gift_badge_label survives the rebuild. */
  function buildGiftWrap(giftLine, opts) {
    opts = opts || {};
    var url = giftLine.url || '#';
    var title = giftLine.product_title || giftLine.title || '';
    var titleEsc = escapeHTML(title);
    var qty = Number(giftLine.quantity) || 1;
    var img = giftLine.image || (giftLine.featured_image && giftLine.featured_image.url) || '';
    var imgHTML = img
      ? '<img class="oddit-cart-drawer__gift-image" alt="' + titleEsc + '" loading="lazy" src="' + escapeHTML(img) + '">'
      : '';

    /* Reuse the previously-rendered badge text (e.g. "FREE GIFT OVER
       $200") if it's present anywhere on the page; otherwise fall back
       to the default. This keeps the rebuilt wrap visually identical
       to what Liquid would produce. */
    var badgeText = opts.badgeText || 'FREE GIFT';

    var wrap = document.createElement('div');
    wrap.className = 'oddit-cart-drawer__gift-wrap';
    wrap.setAttribute('data-cart-gift', '');
    wrap.innerHTML =
      '<div class="oddit-cart-drawer__gift">' +
        '<a class="oddit-cart-drawer__gift-image-wrap" href="' + escapeHTML(url) + '" aria-label="View ' + titleEsc + '">' +
          imgHTML +
          '<span class="oddit-cart-drawer__gift-qty" aria-label="Quantity ' + qty + '">' +
            '<span class="oddit-cart-drawer__gift-qty-x">x</span>' + qty +
          '</span>' +
        '</a>' +
        '<a class="oddit-cart-drawer__gift-title" href="' + escapeHTML(url) + '">' + titleEsc + '</a>' +
        '<span class="oddit-cart-drawer__gift-badge">' +
          '<svg viewBox="0 0 9 9" width="9" height="9" aria-hidden="true" focusable="false">' +
            '<rect x="0.5" y="3" width="8" height="5.5" stroke="currentColor" stroke-width="0.7" fill="none"/>' +
            '<path d="M0 3h9" stroke="currentColor" stroke-width="0.7"/>' +
            '<path d="M4.5 3v5.5" stroke="currentColor" stroke-width="0.7"/>' +
            '<path d="M4.5 3c-1-1.4-2.6-1.4-2.6-0.3 0 0.7 1.3 0.4 2.6 0.3zM4.5 3c1-1.4 2.6-1.4 2.6-0.3 0 0.7-1.3 0.4-2.6 0.3z" stroke="currentColor" stroke-width="0.7" fill="none"/>' +
          '</svg>' +
          '<span>' + escapeHTML(badgeText) + '</span>' +
        '</span>' +
      '</div>';
    return wrap;
  }

  // -------------------------------------------------------
  // Drawer instance
  // -------------------------------------------------------

  function createDrawer(drawer) {
    if (!drawer || drawer.__odditCartInit) return null;
    drawer.__odditCartInit = true;

    var abortController = new AbortController();
    var signal = abortController.signal;
    var lastFocused = null;
    var isOpen = drawer.classList.contains('is-open');

    drawer.style.display = '';

    // ---------- Focus helpers ----------

    function getFocusable() {
      return Array.prototype.filter.call(
        drawer.querySelectorAll(
          'a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'
        ),
        function (el) {
          return el.offsetWidth > 0 || el.offsetHeight > 0 || el === document.activeElement;
        }
      );
    }

    function trapFocus(e) {
      if (e.key !== 'Tab' || !isOpen) return;
      var focusable = getFocusable();
      if (!focusable.length) return;
      var first = focusable[0];
      var last = focusable[focusable.length - 1];
      if (e.shiftKey && document.activeElement === first) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    }

    // ---------- Open / close ----------

    function open(options) {
      if (isOpen) return;
      isOpen = true;
      lastFocused = document.activeElement;
      drawer.classList.add('is-open');
      drawer.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      carouselState.refresh();
      if (!options || !options.skipRefresh) {
        refreshCart().catch(function () {});
      }
      setTimeout(function () {
        var closeBtn = drawer.querySelector('[data-cart-close], .oddit-cart-drawer__close');
        if (closeBtn) {
          try { closeBtn.focus(); } catch (e) {}
        } else {
          var focusable = getFocusable();
          if (focusable.length) {
            try { focusable[0].focus(); } catch (e) {}
          }
        }
      }, 50);
    }

    function close() {
      if (!isOpen) return;
      isOpen = false;
      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
      // If the mobile menu was the layer behind us, close it too so the user
      // doesn't land back in it after dismissing the cart.
      if (window.OdditMobileMenu && window.OdditMobileMenu.isOpen()) {
        window.OdditMobileMenu.close();
      }
      if (lastFocused && typeof lastFocused.focus === 'function') {
        try { lastFocused.focus(); } catch (e) {}
      }
    }

    function toggle() {
      if (isOpen) close(); else open();
    }

    // ---------- Progress bar ----------

    function updateProgressBar(cart) {
      if (!cart) return;

      var thresholdAttr = drawer.getAttribute('data-free-shipping-threshold');
      var thresholdCents = parseFloat(thresholdAttr);
      if (isNaN(thresholdCents)) thresholdCents = 0;

      var totalCents = Number(cart.total_price) || 0;
      var percentage;
      var remainingCents;
      var thresholdReached;

      if (thresholdCents <= 0) {
        percentage = 100;
        remainingCents = 0;
        thresholdReached = true;
      } else {
        percentage = Math.min((totalCents / thresholdCents) * 100, 100);
        remainingCents = Math.max(thresholdCents - totalCents, 0);
        thresholdReached = totalCents >= thresholdCents;
      }

      var fills = drawer.querySelectorAll(
        '[data-cart-progress-fill], .oddit-cart-drawer__progress-fill, .oddit-cart-drawer__shipping-fill'
      );
      Array.prototype.forEach.call(fills, function (fill) {
        fill.style.width = percentage + '%';
      });

      var tracks = drawer.querySelectorAll('[role="progressbar"]');
      Array.prototype.forEach.call(tracks, function (t) {
        t.setAttribute('aria-valuenow', String(Math.round(percentage)));
      });

      var remainingDisplay = formatMoney(remainingCents);

      var inProgressEls = drawer.querySelectorAll(
        '[data-shipping-message="in-progress"], ' +
        '.oddit-cart-drawer__shipping-text, ' +
        '.oddit-cart-drawer__shipping-message--empty'
      );
      Array.prototype.forEach.call(inProgressEls, function (el) {
        /* prefer the merchant-set template carried on the
           data-shipping-message-template attribute. That attribute
           always holds the raw "[amount]" placeholder, so we re-render
           cleanly on every cart/currency change. Fall back to the
           legacy data-template cache + regex patch for older snapshots
           of the cart drawer that don't carry the new attribute. */
        var template = el.getAttribute('data-shipping-message-template');
        if (template != null && template !== '') {
          el.innerHTML = template.replace(/\[amount\]/g, remainingDisplay);
          return;
        }
        template = el.getAttribute('data-template');
        if (template === null) {
          template = el.innerHTML;
          el.setAttribute('data-template', template);
        }
        if (template.indexOf('[amount]') !== -1) {
          el.innerHTML = template.replace(/\[amount\]/g, remainingDisplay);
        } else {
          el.innerHTML = template.replace(/[$£€¥₹]\s?[\d,]+(\.\d{1,2})?/, remainingDisplay);
        }
      });

      var progressWrap = drawer.querySelector('[data-cart-shipping-progress]');
      if (progressWrap) {
        if (thresholdReached) {
          progressWrap.classList.add('is-threshold-reached');
        } else {
          progressWrap.classList.remove('is-threshold-reached');
        }
      }
    }

    // ---------- renderCart orchestrator ----------

    function renderCart(cart, sectionHTML) {
      if (!cart) return;
      if (cart.currency) activeCurrency = cart.currency;

      if (!sectionHTML && cart.sections) {
        sectionHTML = cart.sections[SECTION_TYPE];
      }

      var protectionToggle = drawer.querySelector('[data-cart-protection-toggle]');
      var protectionVariantId = null;
      if (protectionToggle) {
        var pvId = protectionToggle.getAttribute('data-protection-variant-id');
        protectionVariantId = pvId ? Number(pvId) : null;
      }

      var newItemsHTML = extractItemsHTML(sectionHTML);
      if (newItemsHTML === null && cart && Array.isArray(cart.items)) {
        // Section HTML missing or didn't contain the items list — render
        // straight from cart.items so the drawer always reflects the
        // current cart, even when Shopify omits the section for our
        // sections_url.
        newItemsHTML = buildItemsHTML(cart.items, {
          giftProductId: Number(drawer.getAttribute('data-gift-product-id')) || 0,
          protectionProductId: protectionVariantId
            ? (function () {
                for (var p = 0; p < cart.items.length; p++) {
                  if (Number(cart.items[p].variant_id) === protectionVariantId) {
                    return Number(cart.items[p].product_id);
                  }
                }
                return 0;
              })()
            : 0
        });
      }
      if (newItemsHTML !== null) {
        var itemContainers = drawer.querySelectorAll('[data-cart-items]');
        Array.prototype.forEach.call(itemContainers, function (c) {
          c.innerHTML = newItemsHTML;
        });

        /* TL-98: hide stale gift line items from the DOM up-front so
           the customer never sees a stale gift flash as a paid line
           between paint and manageGift's API-side cleanup. A line
           qualifies as a "stale gift" if any of:
             - it carries our explicit `_free_gift` property AND its
               product_id doesn't match the currently configured gift, OR
             - the cart's only remaining items are non-configured items
               that look like gifts (price <= some heuristic) — we
               avoid this fragile path and rely on the property.
           Robustly match line keys by iterating every [data-cart-item]
           and comparing getAttribute against a stale-key set —
           querySelector('[data-cart-item="key:with:colons"]') is fussy
           about Shopify's colon-delimited line keys. */
        var configuredGiftPid = Number(drawer.getAttribute('data-gift-product-id')) || 0;
        var staleKeys = Object.create(null);
        var hasStale = false;
        if (cart && Array.isArray(cart.items)) {
          for (var hi = 0; hi < cart.items.length; hi++) {
            var hit = cart.items[hi];
            var hp = hit.properties || {};
            var hasFreeGiftProp = hp._free_gift === 'true' || hp._free_gift === true;
            var pidMismatch = configuredGiftPid && Number(hit.product_id) !== configuredGiftPid;
            if (hasFreeGiftProp && pidMismatch && hit.key) {
              staleKeys[hit.key] = true;
              hasStale = true;
            }
          }
        }
        if (hasStale) {
          var staleLineEls = drawer.querySelectorAll('[data-cart-item]');
          Array.prototype.forEach.call(staleLineEls, function (el) {
            if (staleKeys[el.getAttribute('data-cart-item')]) {
              el.style.display = 'none';
            }
          });
        }
      }

      // Sync the gift block with the actual cart. Without this, a gift
      // line item that was server-rendered into the section HTML stays
      // visible after we remove it (or vice-versa), so the drawer can
      // show a "ghost" gift that isn't in cart — which checkout then
      // legitimately omits.
      //
      // TL-98: sectionHTML is authoritative for the gift's presence —
      // it's the FRESH server-render that already saw the post-add
      // cart. Earlier this function only consulted `cart.items`, which
      // is empty when we render optimistically from the add response
      // (renderFromSection passes `items: []`), so it would remove the
      // just-added gift block instead of showing it.
      (function syncGiftBlock() {
        var giftProductId = Number(drawer.getAttribute('data-gift-product-id')) || 0;
        if (!giftProductId) return;

        var freshWrap = null;
        if (sectionHTML) {
          try {
            var doc = new DOMParser().parseFromString(sectionHTML, 'text/html');
            freshWrap = doc.querySelector('[data-cart-gift]');
          } catch (_) {}
        }

        /* TL-98: locate the gift line in cart.items even when freshWrap is
           missing. We need this both to decide visibility AND to build a
           fallback wrap below if Shopify's section re-render didn't
           include the gift block. */
        var giftLine = null;
        if (cart && Array.isArray(cart.items)) {
          for (var gi = 0; gi < cart.items.length; gi++) {
            if (Number(cart.items[gi].product_id) === giftProductId) {
              giftLine = cart.items[gi];
              break;
            }
          }
        }
        var inCart = !!freshWrap || !!giftLine;

        var existingWrap = drawer.querySelector('[data-cart-gift]');
        if (!inCart) {
          if (existingWrap && existingWrap.parentNode) {
            existingWrap.parentNode.removeChild(existingWrap);
          }
          return;
        }

        if (!freshWrap && giftLine) {
          var attrBadgeText = drawer.getAttribute('data-gift-badge-text') || 'FREE GIFT';
          freshWrap = buildGiftWrap(giftLine, { badgeText: attrBadgeText });
        }

        /* TL-137: also force the badge text on the SERVER-rendered
           wrap whenever it differs from the drawer's attribute value.
           Handles theme editor preview where the merchant updates the
           label and the section reload paints a wrap whose badge text
           lags the attribute. Cheap, idempotent. */
        if (freshWrap) {
          var attrBadge = drawer.getAttribute('data-gift-badge-text');
          if (attrBadge) {
            var badgeSpan = freshWrap.querySelector('.oddit-cart-drawer__gift-badge span:last-child');
            if (badgeSpan && badgeSpan.textContent !== attrBadge) {
              badgeSpan.textContent = attrBadge;
            }
          }
        }

        if (freshWrap) {
          if (existingWrap && existingWrap.parentNode) {
            existingWrap.parentNode.replaceChild(freshWrap, existingWrap);
          } else {
            var itemsList = drawer.querySelector('[data-cart-items]');
            if (itemsList && itemsList.parentNode) {
              itemsList.parentNode.insertBefore(freshWrap, itemsList.nextSibling);
            }
          }
        }
      })();

      var countEls = drawer.querySelectorAll('[data-cart-count], .oddit-cart-drawer__count');
      Array.prototype.forEach.call(countEls, function (el) {
        var filled = el.querySelector('.oddit-cart-drawer__count-text--filled');
        var emptyEl = el.querySelector('.oddit-cart-drawer__count-text--empty');
        if (filled) filled.textContent = String(cart.item_count);
        if (emptyEl) emptyEl.textContent = '0';
        if (!filled && !emptyEl) el.textContent = String(cart.item_count);
      });

      var subtotalCounts = drawer.querySelectorAll('.oddit-cart-drawer__subtotal-count');
      Array.prototype.forEach.call(subtotalCounts, function (el) {
        el.textContent = String(cart.item_count);
      });

      var subtotalEls = drawer.querySelectorAll('[data-cart-subtotal]');
      Array.prototype.forEach.call(subtotalEls, function (el) {
        el.textContent = formatMoney(cart.total_price);
      });

      updateProgressBar(cart);

      if (cart.item_count === 0) {
        drawer.classList.add('oddit-cart-drawer--empty');
      } else {
        drawer.classList.remove('oddit-cart-drawer--empty');
      }

      var stateContainers = drawer.querySelectorAll('[data-cart-state]');
      Array.prototype.forEach.call(stateContainers, function (el) {
        var state = el.getAttribute('data-cart-state');
        if (state === 'empty') {
          el.style.display = cart.item_count === 0 ? '' : 'none';
        } else if (state === 'filled' || state === 'has-items' || state === 'default') {
          el.style.display = cart.item_count > 0 ? '' : 'none';
        }
      });

      var inCartProductIds = (cart.items || []).map(function (i) {
        return Number(i.product_id);
      });
      var upsellCards = drawer.querySelectorAll('[data-product-id]');
      Array.prototype.forEach.call(upsellCards, function (card) {
        if (card.closest('[data-cart-items]')) return;
        var pid = Number(card.getAttribute('data-product-id'));
        if (inCartProductIds.indexOf(pid) !== -1) {
          card.style.display = 'none';
        } else {
          card.style.display = '';
        }
      });

      if (protectionToggle && protectionVariantId) {
        var hasProtection = (cart.items || []).some(function (i) {
          return Number(i.variant_id) === protectionVariantId;
        });
        protectionToggle.checked = hasProtection;
        drawer.dataset.protectionEnabled = hasProtection ? 'true' : 'false';
      }

      // Dynamic shipping protection price = configured % of cart subtotal,
      // floored at the configured minimum. cart.total_price excludes the
      // protection line item itself so the price stays stable once added.
      var protectionPriceEl = drawer.querySelector('[data-cart-protection-price]');
      if (protectionPriceEl) {
        var pct = parseFloat(protectionPriceEl.getAttribute('data-protection-percent'));
        if (!isNaN(pct) && pct > 0) {
          var min = parseFloat(protectionPriceEl.getAttribute('data-protection-min')) || 0;
          var base = cart.total_price;
          if (protectionVariantId) {
            (cart.items || []).forEach(function (i) {
              if (Number(i.variant_id) === protectionVariantId) {
                base -= i.line_price;
              }
            });
          }
          var amount = Math.round(base * pct / 100);
          if (amount < min) amount = min;
          protectionPriceEl.textContent = formatMoney(amount);
        }
      }

      carouselState.refresh();

      // TL-98: cache the last rendered cart so addToCart/addMultipleToCart
      // can pre-decide whether to bundle the free gift into the SAME
      // /cart/add.js request — avoiding the chained add→fetch→add→fetch
      // round-trip that made the gift line appear visibly late.
      lastCart = cart;

      document.dispatchEvent(
        new CustomEvent('cart:updated', { detail: { cart: cart } })
      );

      manageGift(cart);
    }

    // ---------- Gift auto-add / auto-remove ----------

    var giftBusy = false;
    var lastCart = null;
    // TL-98: guards a race where back-to-back addToCart calls fire before
    // either's response refreshes lastCart — without this, both would see
    // an empty cart and bundle the gift twice.
    var giftBundlePending = false;

    function manageGift(cart) {
      if (giftBusy) return;
      var giftEnabled = drawer.getAttribute('data-gift-enabled') === 'true';
      var giftVariantId = Number(drawer.getAttribute('data-gift-variant-id')) || 0;
      var giftProductId = Number(drawer.getAttribute('data-gift-product-id')) || 0;
      var giftThreshold = Number(drawer.getAttribute('data-gift-threshold')) || 0;
      var giftAvailable = drawer.getAttribute('data-gift-variant-available') !== 'false';
      /* TL-120: master switch wins over the product picker so the
         merchant can pre-stage a gift product (e.g. for a future
         promo) without it auto-adding yet. */
      if (!giftEnabled) return;
      // Nothing to do if the merchant hasn't picked a gift product yet.
      if (!giftVariantId || !giftProductId) return;
      /* TL-98: if Liquid reported the gift variant is unavailable
         (out of stock + inventory tracked + not oversellable), bail
         loudly instead of issuing /cart/add.js requests that always
         422. The merchant's report ("everything is set up but the
         gift doesn't appear") most commonly traces back here. */
      if (!giftAvailable) {
        if (!drawer.__giftUnavailableWarned) {
          drawer.__giftUnavailableWarned = true;
          console.warn(
            '[cart drawer] free-gift variant ' + giftVariantId +
            ' is not available for sale. Either restock the gift product, ' +
            'enable "Continue selling when out of stock" on the variant, ' +
            'or pick a different gift in Theme editor → Cart drawer → ' +
            'Free Gift → Free gift product.'
          );
        }
        return;
      }

      var items = (cart && cart.items) || [];
      var giftLine = null;
      var staleGiftLines = [];
      var nonGiftTotal = 0;
      var nonGiftCount = 0;
      for (var i = 0; i < items.length; i++) {
        var it = items[i];
        if (Number(it.product_id) === giftProductId) {
          giftLine = it;
          continue;
        }
        /* TL-98: a line that carries our `_free_gift` property but isn't
           the currently-configured gift product is a STALE gift (left
           over from a previous theme setting where a different product
           was the gift). Treat it as removable so the new gift can take
           its place — otherwise it lingers in cart at full price (no
           discount target matches it) and the customer is charged. */
        var props = it.properties || {};
        if (props._free_gift === 'true' || props._free_gift === true) {
          staleGiftLines.push(it);
          continue;
        }
        nonGiftTotal += Number(it.line_price) || 0;
        nonGiftCount += Number(it.quantity) || 0;
      }

      /* TL-98: drop any stale gift lines first. Each one fires its own
         apiChangeLine; manageGift will be re-invoked from the resulting
         renderCart and pick up where it left off. */
      if (staleGiftLines.length > 0 && !giftBusy) {
        giftBusy = true;
        var stale = staleGiftLines.shift();
        apiChangeLine({ id: stale.key, quantity: 0 })
          .then(function (next) {
            giftBusy = false;
            renderCart(next);
          })
          .catch(function (err) {
            giftBusy = false;
            console.warn('[cart drawer] could not remove stale gift line', err);
          });
        return;
      }

      // Auto-add the gift whenever the cart has any non-gift items. If a
      // threshold is configured, it acts as an extra gate (subtotal must
      // also clear it). Leaving threshold = 0 means "always include the
      // gift when the cart isn't empty" — matches what most merchants
      // expect after wiring up a 100%-off discount on the gift product.
      var shouldHaveGift = nonGiftCount > 0
        && (giftThreshold <= 0 || nonGiftTotal >= giftThreshold);

      if (shouldHaveGift && !giftLine) {
        giftBusy = true;
        apiAddToCart(giftVariantId, 1, { _free_gift: 'true' })
          .then(function () { return apiGetCart(); })
          .then(function (next) {
            giftBusy = false;
            renderCart(next);
          })
          .catch(function (err) {
            giftBusy = false;
            console.error(
              '[cart drawer] free-gift auto-add failed for variant ' +
                giftVariantId +
                '. Check that the gift product is active, in stock, ' +
                'and that "Continue selling when out of stock" is enabled ' +
                'if you track inventory.',
              (err && (err.data || err.message)) || err
            );
          });
        return;
      }

      if (!shouldHaveGift && giftLine) {
        giftBusy = true;
        apiChangeLine({ id: giftLine.key, quantity: 0 })
          .then(function (next) {
            giftBusy = false;
            renderCart(next);
          })
          .catch(function (err) {
            giftBusy = false;
            console.error('[cart drawer] free-gift auto-remove failed', err);
          });
      }
    }

    // ---------- Cart mutation methods ----------

    // TL-98: If the free gift is configured and isn't currently in the
    // cart, bundle it into the SAME request as `userItems` so the gift
    // line appears in the same render — no second round-trip and no
    // visible delay before the gift shows up.
    function buildItemsWithGift(userItems) {
      /* TL-120: respect the master enable toggle so a pre-staged gift
         product doesn't get bundled into the user's add request when
         the gift is meant to be off. */
      if (drawer.getAttribute('data-gift-enabled') !== 'true') return userItems;
      var giftVariantId = Number(drawer.getAttribute('data-gift-variant-id')) || 0;
      var giftProductId = Number(drawer.getAttribute('data-gift-product-id')) || 0;
      var giftThreshold = Number(drawer.getAttribute('data-gift-threshold')) || 0;
      if (!giftVariantId || !giftProductId) return userItems;

      // Don't bundle if the user is adding the gift itself.
      for (var u = 0; u < userItems.length; u++) {
        if (Number(userItems[u].id) === giftVariantId) return userItems;
      }

      // Skip if gift is already in the cart we last rendered, or a previous
      // bundle is mid-flight and hasn't reconciled with the server yet.
      if (giftBundlePending) return userItems;
      var items = (lastCart && lastCart.items) || [];
      for (var i = 0; i < items.length; i++) {
        if (Number(items[i].product_id) === giftProductId) return userItems;
      }

      // Threshold gate: only bundle when the post-add subtotal would
      // clear it. We approximate using lastCart total since we don't
      // yet know the user item's line_price; the reactive manageGift()
      // still runs as a safety net if our prediction is off.
      if (giftThreshold > 0) {
        var subtotal = (lastCart && Number(lastCart.total_price)) || 0;
        if (subtotal < giftThreshold) return userItems;
      }

      giftBundlePending = true;
      return userItems.concat([
        { id: giftVariantId, quantity: 1, properties: { _free_gift: 'true' } }
      ]);
    }

    // TL-98 v2: paint the drawer from the /cart/add.js response's section
    // HTML BEFORE waiting on /cart.js. Shopify's `sections=` response is
    // rendered against the post-add cart, so it already contains the
    // gift line — the user sees the gift instantly. /cart.js then runs
    // in the background to refresh `lastCart` (for the next add's bundle
    // decision) and to reconcile totals if anything drifted.
    function renderFromAddResponse(addResp, v) {
      if (!addResp || !addResp.sections) return;
      var html = addResp.sections[SECTION_TYPE];
      if (!html) return;
      if (v !== cartReqVersion) return;
      renderFromSection(html);
    }

    function addToCart(variantId, quantity, properties) {
      if (!variantId) return Promise.reject(new Error('variantId is required'));
      var v = nextVersion();
      var userItems = [
        { id: Number(variantId), quantity: Number(quantity) || 1, properties: properties || {} }
      ];
      var items = buildItemsWithGift(userItems);

      // Single item, no gift to bundle → keep the cheaper single-add path.
      var addRequest = items.length === 1
        ? apiAddToCart(variantId, quantity || 1, properties || {})
        : apiAddMultipleToCart(items);

      return addRequest
        .then(function (addResp) {
          renderFromAddResponse(addResp, v);
          return apiGetCart();
        })
        .then(function (cart) {
          giftBundlePending = false;
          if (v === cartReqVersion) renderCart(cart);
          return cart;
        })
        .catch(function (err) {
          giftBundlePending = false;
          throw err;
        });
    }

    function addMultipleToCart(items) {
      var v = nextVersion();
      var withGift = buildItemsWithGift(items || []);
      return apiAddMultipleToCart(withGift)
        .then(function (addResp) {
          renderFromAddResponse(addResp, v);
          return apiGetCart();
        })
        .then(function (cart) {
          giftBundlePending = false;
          if (v === cartReqVersion) renderCart(cart);
          return cart;
        })
        .catch(function (err) {
          giftBundlePending = false;
          throw err;
        });
    }

    function updateLineItemQuantity(lineKey, quantity) {
      if (!lineKey) return Promise.reject(new Error('lineKey is required'));
      var v = nextVersion();
      return apiChangeLine({ id: lineKey, quantity: Number(quantity) || 0 }).then(
        function (cart) {
          if (v === cartReqVersion) renderCart(cart);
          return cart;
        }
      );
    }

    function removeFromCart(lineKey) {
      return updateLineItemQuantity(lineKey, 0);
    }

    function updateLineItemToSubscription(lineKey, sellingPlanId) {
      if (!lineKey) return Promise.reject(new Error('lineKey is required'));
      return apiChangeLine({ id: lineKey, selling_plan: sellingPlanId }).then(
        function (cart) {
          renderCart(cart);
          return cart;
        }
      );
    }

    // Monotonic counter incremented every time we kick off a cart-mutating
    // request. apiGetCart responses captured before the counter advances
    // are stale (the cart has since changed) and would otherwise overwrite
    // newer state — see `refreshCart` / `addToCart` below.
    var cartReqVersion = 0;

    function nextVersion() {
      cartReqVersion += 1;
      return cartReqVersion;
    }

    function refreshCart() {
      var v = cartReqVersion;
      return apiGetCart().then(function (cart) {
        if (v !== cartReqVersion) return cart; // stale, newer mutation in flight
        renderCart(cart);
        return cart;
      });
    }

    function renderFromSection(sectionHTML) {
      if (!sectionHTML) return null;
      var doc;
      try {
        doc = new DOMParser().parseFromString(sectionHTML, 'text/html');
      } catch (e) {
        return null;
      }
      var root = doc.querySelector('[data-cart-drawer]');
      if (!root) return null;

      var itemCount = parseInt(root.getAttribute('data-cart-item-count'), 10);
      if (isNaN(itemCount)) itemCount = 0;
      var totalPrice = parseInt(root.getAttribute('data-cart-total-price'), 10);
      if (isNaN(totalPrice)) totalPrice = 0;

      var partialCart = {
        item_count: itemCount,
        total_price: totalPrice,
        items: []
      };
      renderCart(partialCart, sectionHTML);
      return partialCart;
    }

    // ---------- Wiring ----------

    function setBusy(btn, busy) {
      if (!btn) return;
      if (busy) {
        btn.disabled = true;
        btn.setAttribute('aria-busy', 'true');
      } else {
        btn.disabled = false;
        btn.removeAttribute('aria-busy');
      }
    }

    function bindCoreUI() {
      var overlay = drawer.querySelector('[data-cart-overlay], .oddit-cart-drawer__overlay');
      if (overlay) {
        overlay.addEventListener('click', close, { signal: signal });
      }

      var closeBtns = drawer.querySelectorAll('[data-cart-close], .oddit-cart-drawer__close');
      Array.prototype.forEach.call(closeBtns, function (btn) {
        btn.addEventListener(
          'click',
          function (e) {
            e.preventDefault();
            close();
          },
          { signal: signal }
        );
      });

      document.addEventListener(
        'keydown',
        function (e) {
          if (e.key === 'Escape' && isOpen) {
            e.preventDefault();
            close();
            return;
          }
          if (e.key === 'Tab') trapFocus(e);
        },
        { signal: signal }
      );

      var checkoutBtns = drawer.querySelectorAll(
        'button[data-cart-checkout], button.oddit-cart-drawer__checkout-cta'
      );
      Array.prototype.forEach.call(checkoutBtns, function (btn) {
        btn.addEventListener(
          'click',
          function (e) {
            e.preventDefault();
            window.location.href = '/checkout';
          },
          { signal: signal }
        );
      });

      var protectionToggle = drawer.querySelector('[data-cart-protection-toggle]');
      if (protectionToggle) {
        protectionToggle.addEventListener(
          'change',
          function () {
            var variantIdAttr = protectionToggle.getAttribute('data-protection-variant-id');
            if (!variantIdAttr) return;
            var variantId = Number(variantIdAttr);
            drawer.dataset.protectionEnabled = protectionToggle.checked ? 'true' : 'false';
            protectionToggle.disabled = true;

            var op;
            if (protectionToggle.checked) {
              op = addToCart(variantId, 1);
            } else {
              op = apiGetCart().then(function (cart) {
                var match = (cart.items || []).find(function (i) {
                  return Number(i.variant_id) === variantId;
                });
                if (match) return updateLineItemQuantity(match.key, 0);
                renderCart(cart);
                return cart;
              });
            }
            op.catch(function () {}).then(function () {
              protectionToggle.disabled = false;
            });
          },
          { signal: signal }
        );
      }

      var itemContainers = drawer.querySelectorAll('[data-cart-items]');
      Array.prototype.forEach.call(itemContainers, function (container) {
        container.addEventListener(
          'click',
          function (e) {
            var qtyBtn = e.target.closest(
              '[data-quantity-action], [data-cart-qty-decrease], [data-cart-qty-increase]'
            );
            var removeBtn = e.target.closest('[data-remove-line], [data-cart-remove]');

            if (removeBtn) {
              e.preventDefault();
              var rkey = removeBtn.getAttribute('data-line-key');
              if (!rkey) return;
              setBusy(removeBtn, true);
              removeFromCart(rkey)
                .catch(function () {})
                .then(function () {
                  setBusy(removeBtn, false);
                });
              return;
            }

            if (qtyBtn) {
              e.preventDefault();
              var key = qtyBtn.getAttribute('data-line-key');
              if (!key) return;
              var item = qtyBtn.closest('.oddit-cart-drawer__item');
              var qtyValueEl = item
                ? item.querySelector('[data-cart-qty-value], .oddit-cart-drawer__qty-value')
                : null;
              var current = qtyValueEl
                ? parseInt(qtyValueEl.textContent, 10) || 1
                : 1;
              var action = qtyBtn.getAttribute('data-quantity-action');
              var isIncrease =
                action === 'increase' ||
                qtyBtn.hasAttribute('data-cart-qty-increase');
              var next = isIncrease ? current + 1 : Math.max(0, current - 1);
              setBusy(qtyBtn, true);
              updateLineItemQuantity(key, next)
                .catch(function () {})
                .then(function () {
                  setBusy(qtyBtn, false);
                });
            }
          },
          { signal: signal }
        );
      });

      var recAddBtns = drawer.querySelectorAll(
        '.oddit-cart-drawer__rec-add[data-variant-id]'
      );
      Array.prototype.forEach.call(recAddBtns, function (btn) {
        btn.addEventListener(
          'click',
          function (e) {
            e.preventDefault();
            var vid = btn.getAttribute('data-variant-id');
            if (!vid) return;
            setBusy(btn, true);
            addToCart(Number(vid), 1)
              .catch(function () {})
              .then(function () {
                setBusy(btn, false);
              });
          },
          { signal: signal }
        );
      });

      var upsellBtns = drawer.querySelectorAll(
        '.oddit-cart-drawer__upsell-cta[data-variant-id]'
      );
      Array.prototype.forEach.call(upsellBtns, function (btn) {
        btn.addEventListener(
          'click',
          function (e) {
            e.preventDefault();
            var vid = btn.getAttribute('data-variant-id');
            if (!vid) return;
            setBusy(btn, true);
            addToCart(Number(vid), 1)
              .catch(function () {})
              .then(function () {
                setBusy(btn, false);
              });
          },
          { signal: signal }
        );
      });

      var switchBtns = drawer.querySelectorAll(
        '.oddit-cart-drawer__switch-cta[data-selling-plan-id]'
      );
      Array.prototype.forEach.call(switchBtns, function (btn) {
        btn.addEventListener(
          'click',
          function (e) {
            e.preventDefault();
            var planId = btn.getAttribute('data-selling-plan-id');
            if (!planId) return;
            setBusy(btn, true);
            apiGetCart()
              .then(function (cart) {
                var pending = (cart.items || []).filter(function (i) {
                  return !i.selling_plan_allocation;
                });
                var chain = Promise.resolve(cart);
                pending.forEach(function (it) {
                  chain = chain.then(function () {
                    return updateLineItemToSubscription(it.key, planId);
                  });
                });
                return chain;
              })
              .catch(function () {})
              .then(function () {
                setBusy(btn, false);
              });
          },
          { signal: signal }
        );
      });

      var thumbnailGroups = drawer.querySelectorAll('.oddit-cart-drawer__product-thumbnails');
      Array.prototype.forEach.call(thumbnailGroups, function (group) {
        var thumbs = group.querySelectorAll('.oddit-cart-drawer__product-thumbnail');
        Array.prototype.forEach.call(thumbs, function (thumb) {
          thumb.addEventListener(
            'click',
            function () {
              Array.prototype.forEach.call(thumbs, function (t) {
                t.classList.remove('oddit-cart-drawer__product-thumbnail--active');
                t.setAttribute('aria-pressed', 'false');
              });
              thumb.classList.add('oddit-cart-drawer__product-thumbnail--active');
              thumb.setAttribute('aria-pressed', 'true');

              var variantId = thumb.getAttribute('data-variant-id');
              if (!variantId) return;
              var card = thumb.closest('[data-cross-sell-card]');
              if (!card) return;
              var form = card.querySelector('[data-cross-sell-add-form]');
              if (form) {
                var idInput = form.querySelector('input[name="id"]');
                if (idInput) idInput.value = variantId;
              }
              var addBtn = card.querySelector('[data-cross-sell-add]');
              if (addBtn) addBtn.setAttribute('data-variant-id', variantId);
            },
            { signal: signal }
          );
        });
      });

      var triggers = document.querySelectorAll(
        '[data-cart-drawer-open], [data-open-cart-drawer]'
      );
      Array.prototype.forEach.call(triggers, function (trigger) {
        trigger.addEventListener(
          'click',
          function (e) {
            e.preventDefault();
            open();
          },
          { signal: signal }
        );
      });

      var crossSellCards = drawer.querySelectorAll('[data-cross-sell-card]');
      Array.prototype.forEach.call(crossSellCards, function (card) {
        card.addEventListener(
          'click',
          function (e) {
            // Let interactive controls inside the card (e.g. color swatches, links) handle their own clicks.
            if (e.target.closest('a, button, input, select, textarea, [role="button"]')) return;
            var url = card.getAttribute('data-product-url');
            if (!url) return;
            if (e.metaKey || e.ctrlKey || e.shiftKey || e.button === 1) {
              window.open(url, '_blank');
            } else {
              window.location.href = url;
            }
          },
          { signal: signal }
        );
      });

      function handleCrossSellAdd(btn) {
        if (btn.disabled) return;
        var form = btn.closest('[data-cross-sell-add-form]');
        var idInput = form ? form.querySelector('input[name="id"]') : null;
        var vid = (idInput && idInput.value) || btn.getAttribute('data-variant-id');
        if (!vid) return;

        var label = btn.querySelector('.oddit-cart-drawer__product-add-label');
        var originalText = label ? label.textContent : btn.textContent;
        btn.disabled = true;
        if (label) label.textContent = 'Adding…';
        else btn.textContent = 'Adding…';

        addToCart(Number(vid), 1)
          .then(function () {
            if (!isOpen) open({ skipRefresh: true });
            var body = drawer.querySelector('.oddit-cart-drawer__body');
            if (body) {
              if (typeof body.scrollTo === 'function') {
                try { body.scrollTo({ top: 0, behavior: 'smooth' }); }
                catch (_) { body.scrollTop = 0; }
              } else {
                body.scrollTop = 0;
              }
            }
            if (label) label.textContent = 'Added';
            else btn.textContent = 'Added';
            setTimeout(function () {
              if (label) label.textContent = originalText;
              else btn.textContent = originalText;
              btn.disabled = false;
            }, 1200);
          })
          .catch(function (err) {
            console.error('[cart drawer] addToCart failed for vid', vid, err);
            if (label) label.textContent = originalText;
            else btn.textContent = originalText;
            btn.disabled = false;
          });
      }

      // Belt: delegated at the drawer (capture phase) so handlers can't
      // be lost across partial re-renders and we catch the click before
      // the parent card's navigation handler fires.
      drawer.addEventListener(
        'click',
        function (e) {
          var btn = e.target.closest('[data-cross-sell-add]');
          if (!btn || !drawer.contains(btn)) return;
          e.preventDefault();
          e.stopPropagation();
          handleCrossSellAdd(btn);
        },
        { signal: signal, capture: true }
      );

      // Suspenders: direct per-button binding in case some upstream
      // listener consumes the click before delegation can see it.
      var crossSellAddBtns = drawer.querySelectorAll('[data-cross-sell-add]');
      Array.prototype.forEach.call(crossSellAddBtns, function (btn) {
        btn.addEventListener(
          'click',
          function (e) {
            e.preventDefault();
            e.stopPropagation();
            handleCrossSellAdd(btn);
          },
          { signal: signal }
        );
      });
    }

    // ---------- Cross-sell carousel ----------

    var carouselState = { update: function () {}, refresh: function () {} };

    function bindCrossSellCarousel() {
      var track = drawer.querySelector('[data-cart-cross-sell-products]');
      if (!track) return;

      var prevBtn = drawer.querySelector('[data-cart-cross-sell-prev]');
      var nextBtn = drawer.querySelector('[data-cart-cross-sell-next]');
      var dotsEl = drawer.querySelector('[data-cart-cross-sell-dots]');
      var nav = drawer.querySelector('.oddit-cart-drawer__carousel-nav');

      function visibleCards() {
        var cards = track.querySelectorAll('.oddit-cart-drawer__product-card');
        return Array.prototype.filter.call(cards, function (c) {
          return c.offsetParent !== null && c.style.display !== 'none';
        });
      }

      function cardStep(cards) {
        if (cards.length >= 2) {
          var step = cards[1].offsetLeft - cards[0].offsetLeft;
          if (step > 0) return step;
        }
        return cards[0] ? cards[0].offsetWidth : 0;
      }

      function maxScroll() {
        return Math.max(0, track.scrollWidth - track.clientWidth);
      }

      function pageCount() {
        var cards = visibleCards();
        if (!cards.length) return 0;
        var max = maxScroll();
        if (max <= 1) return 1;
        var step = cardStep(cards);
        if (step <= 0) return 1;
        var pages = Math.ceil(max / step) + 1;
        return Math.min(pages, cards.length);
      }

      function activeIndex() {
        var cards = visibleCards();
        if (!cards.length) return 0;
        var max = maxScroll();
        if (max <= 1) return 0;
        if (track.scrollLeft >= max - 1) return pageCount() - 1;
        var step = cardStep(cards);
        if (step <= 0) return 0;
        return Math.max(0, Math.min(Math.round(track.scrollLeft / step), pageCount() - 1));
      }

      function scrollToIndex(i) {
        var cards = visibleCards();
        if (!cards.length) return;
        var pages = pageCount();
        var clamped = Math.max(0, Math.min(i, pages - 1));
        var target;
        if (clamped >= pages - 1) {
          target = maxScroll();
        } else {
          target = cards[clamped] ? cards[clamped].offsetLeft : 0;
        }
        try {
          track.scrollTo({ left: target, behavior: 'smooth' });
        } catch (e) {
          track.scrollLeft = target;
        }
      }

      function update() {
        var cards = visibleCards();
        var hasOverflow = track.scrollWidth - track.clientWidth > 1;
        var pages = hasOverflow ? pageCount() : 1;

        if (nav) nav.style.display = hasOverflow && pages > 1 ? '' : 'none';

        if (dotsEl) {
          if (!hasOverflow || pages <= 1) {
            dotsEl.innerHTML = '';
          } else {
            var existing = dotsEl.querySelectorAll('.oddit-cart-drawer__carousel-dot');
            if (existing.length !== pages) {
              dotsEl.innerHTML = '';
              for (var i = 0; i < pages; i++) {
                var dot = document.createElement('button');
                dot.type = 'button';
                dot.className = 'oddit-cart-drawer__carousel-dot';
                dot.setAttribute('aria-label', 'Go to slide ' + (i + 1));
                dot.setAttribute('data-cart-cross-sell-dot', String(i));
                dotsEl.appendChild(dot);
              }
            }
            var dots = dotsEl.querySelectorAll('.oddit-cart-drawer__carousel-dot');
            var idx = activeIndex();
            Array.prototype.forEach.call(dots, function (d, i) {
              if (i === idx) d.classList.add('oddit-cart-drawer__carousel-dot--active');
              else d.classList.remove('oddit-cart-drawer__carousel-dot--active');
            });
          }
        }

        var idx = activeIndex();
        if (prevBtn) prevBtn.disabled = !hasOverflow || idx <= 0;
        if (nextBtn) nextBtn.disabled = !hasOverflow || idx >= pages - 1;
      }

      if (prevBtn) {
        prevBtn.addEventListener('click', function (e) {
          e.preventDefault();
          scrollToIndex(activeIndex() - 1);
        }, { signal: signal });
      }

      if (nextBtn) {
        nextBtn.addEventListener('click', function (e) {
          e.preventDefault();
          scrollToIndex(activeIndex() + 1);
        }, { signal: signal });
      }

      if (dotsEl) {
        dotsEl.addEventListener('click', function (e) {
          var dot = e.target.closest('[data-cart-cross-sell-dot]');
          if (!dot) return;
          e.preventDefault();
          var i = parseInt(dot.getAttribute('data-cart-cross-sell-dot'), 10);
          if (!isNaN(i)) scrollToIndex(i);
        }, { signal: signal });
      }

      var rafId = 0;
      track.addEventListener('scroll', function () {
        if (rafId) cancelAnimationFrame(rafId);
        rafId = requestAnimationFrame(update);
      }, { signal: signal, passive: true });

      // Mouse drag (desktop). Native touch handles mobile via overflow-x: auto.
      var dragging = false;
      var pointerId = null;
      var startX = 0;
      var startScroll = 0;
      var moved = false;

      track.addEventListener('pointerdown', function (e) {
        if (e.pointerType !== 'mouse') return;
        if (e.button !== 0) return;
        // Skip drag tracking entirely when the pointerdown lands on an
        // interactive control inside a card (Add button, color swatch,
        // product link). Tiny mouse jitter during a click otherwise
        // crosses the drag threshold, flips `is-dragging`, and the
        // resulting pointer-events:none hides the click target.
        if (
          e.target.closest(
            '[data-cross-sell-add], a, button, input, select, textarea, [role="button"]'
          )
        ) return;
        dragging = true;
        moved = false;
        pointerId = e.pointerId;
        startX = e.clientX;
        startScroll = track.scrollLeft;
      }, { signal: signal });

      track.addEventListener('pointermove', function (e) {
        if (!dragging || e.pointerId !== pointerId) return;
        var dx = e.clientX - startX;
        if (Math.abs(dx) > 8) {
          if (!moved) {
            moved = true;
            track.classList.add('is-dragging');
            try { track.setPointerCapture(pointerId); } catch (err) {}
          }
          track.scrollLeft = startScroll - dx;
        }
      }, { signal: signal });

      function endDrag(e) {
        if (!dragging) return;
        if (e && e.pointerId !== undefined && e.pointerId !== pointerId) return;
        dragging = false;
        track.classList.remove('is-dragging');
        try { if (pointerId !== null) track.releasePointerCapture(pointerId); } catch (err) {}
        pointerId = null;
        // Block the synthetic click that follows a drag
        if (moved) {
          var blockClick = function (ev) {
            ev.preventDefault();
            ev.stopPropagation();
            track.removeEventListener('click', blockClick, true);
          };
          track.addEventListener('click', blockClick, true);
          setTimeout(function () {
            track.removeEventListener('click', blockClick, true);
          }, 0);
        }
      }

      track.addEventListener('pointerup', endDrag, { signal: signal });
      track.addEventListener('pointercancel', endDrag, { signal: signal });
      track.addEventListener('pointerleave', endDrag, { signal: signal });

      var resizeRaf = 0;
      window.addEventListener('resize', function () {
        if (resizeRaf) cancelAnimationFrame(resizeRaf);
        resizeRaf = requestAnimationFrame(update);
      }, { signal: signal });

      carouselState.update = update;
      carouselState.refresh = function () {
        // Defer to next frame so layout settles after items re-render or open.
        requestAnimationFrame(update);
      };

      update();
    }

    bindCoreUI();
    bindCrossSellCarousel();

    // TL-98: Reconcile the free gift on page load. Without this, the
    // gift only gets added when something triggers renderCart — so a
    // customer who lands on /cart (or any page) with a non-empty cart
    // but no gift line stays giftless until they open the drawer.
    // Calling manageGift directly is intentional: it owns its own
    // renderCart call when it actually adds/removes, so the page-load
    // path stays a no-op visually unless a real cart mutation happens.
    Promise.resolve().then(function () {
      var giftProductId = Number(drawer.getAttribute('data-gift-product-id')) || 0;
      var giftVariantId = Number(drawer.getAttribute('data-gift-variant-id')) || 0;
      if (!giftProductId || !giftVariantId) return;
      apiGetCart()
        .then(function (cart) { manageGift(cart); })
        .catch(function () {});
    });

    function destroy() {
      try { abortController.abort(); } catch (e) {}
      drawer.__odditCartInit = false;
    }

    var instance = {
      el: drawer,
      open: open,
      close: close,
      toggle: toggle,
      addToCart: addToCart,
      addMultipleToCart: addMultipleToCart,
      updateLineItemQuantity: updateLineItemQuantity,
      removeFromCart: removeFromCart,
      updateLineItemToSubscription: updateLineItemToSubscription,
      getCart: apiGetCart,
      refreshCart: refreshCart,
      renderCart: renderCart,
      renderFromSection: renderFromSection,
      updateProgressBar: updateProgressBar,
      destroy: destroy
    };

    instances.push(instance);

    /* TL-100: render the shipping-progress message once at init time
       using the JS-active currency. Without this we can show whatever
       Liquid baked into the message at deploy time — including the
       broken ".0000.00" that surfaced after currency switching with
       an empty cart. Pull cart state from the data-* hints on the
       drawer wrapper so we don't need to wait for a network round-trip.
       Real fetched cart state still updates this on the next open. */
    try {
      var totalAttr = drawer.getAttribute('data-cart-total-price');
      var countAttr = drawer.getAttribute('data-cart-item-count');
      var initialCart = {
        total_price: totalAttr == null ? 0 : Number(totalAttr) || 0,
        item_count: countAttr == null ? 0 : Number(countAttr) || 0
      };
      updateProgressBar(initialCart);
    } catch (_) { /* harmless — next refreshCart will fix it */ }

    return instance;
  }

  // -------------------------------------------------------
  // Public API — window.OdditCartDrawer
  // -------------------------------------------------------

  function firstInstance() {
    return instances[0] || null;
  }

  function dispatchUpdated(cart) {
    document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cart } }));
  }

  var OdditCartDrawer = {
    open: function (options) {
      var inst = firstInstance();
      if (inst) inst.open(options);
    },
    close: function () {
      var inst = firstInstance();
      if (inst) inst.close();
    },
    toggle: function () {
      var inst = firstInstance();
      if (inst) inst.toggle();
    },
    addToCart: function (variantId, quantity, properties) {
      var inst = firstInstance();
      if (inst) {
        var p = inst.addToCart(variantId, quantity, properties);
        /* TL-98 (followup): defer the drawer open until addToCart's
           render pipeline has finished (renderFromAddResponse +
           renderCart). Opening optimistically showed the PREVIOUS
           cart state — including any pre-existing gift item rendered
           as a normal line with its real price — for the duration of
           the network round-trip, which read as "gift flashes priced,
           then becomes the FREE GIFT block". skipRefresh is still
           passed so open() doesn't fire its own /cart.js fetch and
           race the one already running inside addToCart. */
        p.then(function () { inst.open({ skipRefresh: true }); })
          .catch(function () { /* don't open on add failure */ });
        return p;
      }
      return apiAddToCart(variantId, quantity || 1, properties || {})
        .then(apiGetCart)
        .then(function (cart) {
          dispatchUpdated(cart);
          return cart;
        });
    },
    addMultipleToCart: function (items) {
      var inst = firstInstance();
      if (inst) {
        var p = inst.addMultipleToCart(items);
        /* TL-98 (followup): defer the drawer open — see addToCart above. */
        p.then(function () { inst.open({ skipRefresh: true }); })
          .catch(function () { /* don't open on add failure */ });
        return p;
      }
      return apiAddMultipleToCart(items || [])
        .then(apiGetCart)
        .then(function (cart) {
          dispatchUpdated(cart);
          return cart;
        });
    },
    removeFromCart: function (lineKey) {
      var inst = firstInstance();
      if (inst) return inst.removeFromCart(lineKey);
      return apiChangeLine({ id: lineKey, quantity: 0 }).then(function (cart) {
        dispatchUpdated(cart);
        return cart;
      });
    },
    updateLineItemQuantity: function (lineKey, quantity) {
      var inst = firstInstance();
      if (inst) return inst.updateLineItemQuantity(lineKey, quantity);
      return apiChangeLine({ id: lineKey, quantity: Number(quantity) || 0 }).then(
        function (cart) {
          dispatchUpdated(cart);
          return cart;
        }
      );
    },
    updateLineItemToSubscription: function (lineKey, sellingPlanId) {
      var inst = firstInstance();
      if (inst) return inst.updateLineItemToSubscription(lineKey, sellingPlanId);
      return apiChangeLine({ id: lineKey, selling_plan: sellingPlanId }).then(
        function (cart) {
          dispatchUpdated(cart);
          return cart;
        }
      );
    },
    getCart: function () {
      return apiGetCart();
    },
    refreshCart: function () {
      var inst = firstInstance();
      if (inst) return inst.refreshCart();
      return apiGetCart().then(function (cart) {
        dispatchUpdated(cart);
        return cart;
      });
    },
    renderCart: function (cart) {
      instances.forEach(function (i) {
        i.renderCart(cart);
      });
    },
    renderFromSection: function (sectionHTML) {
      var result = null;
      instances.forEach(function (i) {
        var r = i.renderFromSection(sectionHTML);
        if (r) result = r;
      });
      return result;
    },
    formatMoney: formatMoney,
    instances: instances
  };

  window.OdditCartDrawer = OdditCartDrawer;

  // -------------------------------------------------------
  // Init / theme editor lifecycle
  // -------------------------------------------------------

  function initAll(root) {
    var scope = root || document;
    var drawers = scope.querySelectorAll('.oddit-cart-drawer, [data-cart-drawer]');
    Array.prototype.forEach.call(drawers, function (d) {
      if (!d.__odditCartInit) createDrawer(d);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll(document);
    });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (e) {
    if (!e.target) return;
    if (
      e.target.matches &&
      e.target.matches('.oddit-cart-drawer, [data-cart-drawer]')
    ) {
      createDrawer(e.target);
    } else {
      initAll(e.target);
    }
  });

  document.addEventListener('shopify:section:unload', function (e) {
    if (!e.target) return;
    for (var i = instances.length - 1; i >= 0; i--) {
      var el = instances[i].el;
      if (el === e.target || (e.target.contains && e.target.contains(el))) {
        instances[i].destroy();
        instances.splice(i, 1);
      }
    }
  });

  // -------------------------------------------------------------------
  // TL-112: Global click handler for upsell Add buttons.
  // Runs at top level (outside createDrawer) so it works even if the
  // per-drawer init never ran. Prefers OdditCartDrawer.addToCart so the
  // full drawer (items list, subtotal, shipping bar) re-renders after
  // add. Falls back to a raw fetch only if the API isn't present.
  // -------------------------------------------------------------------
  document.addEventListener('click', function (e) {
    var btn = e.target && e.target.closest && e.target.closest('[data-cross-sell-add]');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    if (btn.disabled) return;
    var vid = btn.getAttribute('data-variant-id');
    if (!vid) return;
    var label = btn.querySelector('.oddit-cart-drawer__product-add-label');
    var originalText = label ? label.textContent : btn.textContent;
    btn.disabled = true;
    if (label) label.textContent = 'Adding…';
    else btn.textContent = 'Adding…';

    var p;
    if (window.OdditCartDrawer && typeof window.OdditCartDrawer.addToCart === 'function') {
      p = window.OdditCartDrawer.addToCart(Number(vid), 1);
    } else {
      p = fetch('/cart/add.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify({ id: Number(vid), quantity: 1 })
      }).then(function (res) {
        if (!res.ok) throw new Error('HTTP ' + res.status);
        return res.json();
      });
    }

    Promise.resolve(p)
      .then(function () {
        if (label) label.textContent = 'Added';
        else btn.textContent = 'Added';
        setTimeout(function () {
          if (label) label.textContent = originalText;
          else btn.textContent = originalText;
          btn.disabled = false;
        }, 1200);
      })
      .catch(function (err) {
        console.error('[cart drawer] add to cart failed', err);
        if (label) label.textContent = originalText;
        else btn.textContent = originalText;
        btn.disabled = false;
      });
  }, true);
})();